<ngx-spinner [name]="'consultar-produto'" type="ball-clip-rotate-pulse" [fullScreen]="false"
    bdColor="rgba(0, 0, 0, 0.2)"></ngx-spinner>
<mat-card>
    <mat-card-header>
        <mat-card-title>Entrada / Saída de estoque</mat-card-title>
    </mat-card-header>
    <mat-divider></mat-divider>

    <mat-card-content>
        <form [formGroup]="consultaForm">
            <div class="row">

                <div class="col-sm">
                    <mat-form-field appearance="outline" [floatLabel]="'always'">
                        <mat-label>Descrição (Nome do Produto)</mat-label>
                        <input type="text" matInput formControlName="nomeProduto" maxlength="100"
                            (keypress)="omit_special_char($event)" [matAutocomplete]="auto"
                            (ngModelChange)="onChangeNomeProduto($event)">
                        <mat-hint *ngIf="bCaracterEspecial" align="start" style="color: red;"> Não são permitidos
                            acentos ou
                            caracteres especiais </mat-hint>
                    </mat-form-field>
                    <mat-autocomplete #auto="matAutocomplete">
                        <mat-option *ngFor="let prod of produtos" [value]="prod.Nome"
                            (onSelectionChange)="adicionarProduto(prod)">
                            {{prod.Nome}}
                        </mat-option>
                    </mat-autocomplete>
                </div>
            </div>
        </form>

        <div class="row mt-2">
            <mat-divider></mat-divider>
        </div>

        <div class="row mt-2">
            <div class="col-auto">
                <mat-form-field appearance="outline" [floatLabel]="'always'">
                    <mat-label>Filtro</mat-label>
                    <input id="inputFiltro" [(ngModel)]="filtroTabela" matInput (keyup)="aplicarFiltroTabela($event)"
                        placeholder="Filtro" autofocus>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col-sm">
                <div style="color: gray; font-size: small;">* O valor informado no campo "Incrementar / Subtrair (Qnt.) será acrescido ou debitádo do seu estoque final.</div>
            </div>
        </div>

        <div class="row">
            <div class="col-sm">
                <div style="color: gray; font-size: small;">* Poderá haver uma compra do produto no momento da atualização, o campo "Qnt. Estoque" exibe o dado recebido no momento da busca.</div>
            </div>
        </div>

        <div class="row">
            <div class="col-sm">
                <div style="color: gray; font-size: small;">* Em caso de algum erro na transação do estoque, confira o estoque do item através de uma nova consulta após a liberação da página.</div>
            </div>
        </div>

        <div class="row">
            <div class="col-sm">
                <div style="color: gray; font-size: small;">* Para subtrair um item, certifique-se que há apenas um sinal de subtração no campo ou a operação será anulada.</div>
            </div>
        </div>

        <div class="row mt-4">
            <div class="col-sm">
                <table mat-table [dataSource]="produtosSource" class="mat-elevation-z2">

                    <ng-container matColumnDef="Codigo">
                        <th mat-header-cell *matHeaderCellDef> Código </th>
                        <td mat-cell *matCellDef="let element"> {{element.CodigoProduto}} </td>
                    </ng-container>

                    <ng-container matColumnDef="Nome">
                        <th mat-header-cell *matHeaderCellDef> Descrição (Nome) </th>
                        <td mat-cell *matCellDef="let element"> {{element.Nome}} </td>
                    </ng-container>

                    <ng-container matColumnDef="Valor">
                        <th mat-header-cell *matHeaderCellDef> Valor </th>
                        <td mat-cell *matCellDef="let element"> {{element.ValorString}} </td>
                    </ng-container>

                    <ng-container matColumnDef="QntEstoque">
                        <th mat-header-cell *matHeaderCellDef> Qnt. Estoque </th>
                        <td mat-cell *matCellDef="let element">
                            <div class="retangulo_tabela"
                                [ngStyle]="{'background': (element.QuantidadeEstoque > 0) ? '#42D697' : '#F34770' }">
                                {{element.QuantidadeEstoque}}
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="QuantidadeMinimaAlertaEstoque">
                        <th mat-header-cell *matHeaderCellDef> Qnt. Mínima Alerta Estoque </th>
                        <td mat-cell *matCellDef="let element">
                            <mat-form-field floatLabel="never">
                                <input matInput type="number" placeholder="Quantidade mínima para alerta"
                                    [value]="element.QuantidadeMinimaAlertaEstoque"
                                    [(ngModel)]="element.QuantidadeMinimaAlertaEstoque" disabled>
                            </mat-form-field>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="AdcRemover">
                        <th mat-header-cell *matHeaderCellDef> Incrementar / Subtrair (Qnt.) </th>
                        <td mat-cell *matCellDef="let element">
                            <mat-form-field floatLabel="never">
                                <input matInput type="number" placeholder="Quantidade para adicionar ou remover"
                                    [value]="element.AdcRemover" [(ngModel)]="element.AdcRemover">
                            </mat-form-field>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="RemoverProduto">
                        <th mat-header-cell *matHeaderCellDef> Remover </th>
                        <td mat-cell *matCellDef="let element">
                            <button mat-icon-button matTooltip="Remover" (click)="removerProduto(element)"
                                class="iconbutton" color="primary">
                                <mat-icon aria-label="Remover">close</mat-icon>
                            </button>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                    <!-- Row shown when there is no matching data that will be provided to the wrapper table. -->
                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell" colspan="7" style="text-align: center;">Nenhum item adicionado para modificar o estoque
                        </td>
                    </tr>
                </table>

                <mat-paginator [pageSizeOptions]="[20, 40, 60, 80, 100, 200]"></mat-paginator>
            </div>
        </div>


        <div class="row">
            <div class="col-sm">
                <mat-divider></mat-divider>
            </div>
        </div>

        <div class="row mt-2" *ngIf="produtosLista.length > 0">
            <div class="col-auto">
                <button mat-flat-button color="warn" (click)="limparCampos()">
                    <mat-icon>clear</mat-icon> Cancelar
                </button>
            </div>

            <div class="col-sm text-right">
                <button mat-flat-button color="primary" (click)="salvar()">
                    <mat-icon>check</mat-icon> Aplicar estoque
                </button>
            </div>
        </div>

    </mat-card-content>
</mat-card>